import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSidenav} from "@angular/material/sidenav";
import {Router} from "@angular/router";
import {AuthenticationService} from "../auth/services/authentication.service";
import {User} from "../auth/models/User";
import {Role} from "../auth/models/Role";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.scss']
})
export class AdminPanelComponent implements OnInit {
  @ViewChild('sidenav', {static: false}) sidenav!: MatSidenav;
  sidenavSmall: boolean = false;

  public hasLoggedInUser = false;
  public isAdministrator = false;
  public isCustomer = false;
  public isCoach = false;
  currentUser: User | null = null;
  currentLang: string = 'sq';

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private translate: TranslateService
  ) {
    this.authenticationService.currentUser.subscribe(x => {
      this.currentUser = x;
      this.hasLoggedInUser = !!x;

      if (x && x.roles) {
        this.isAdministrator = x.roles.includes(Role.Admin);
        this.isCustomer = x.roles.includes(Role.User);
        this.isCoach = x.roles.includes(Role.Coach);
      } else {
        this.isAdministrator = false;
        this.isCustomer = false;
        this.isCoach = false;
      }
    });
    const savedLang = localStorage.getItem('lang');
    const defaultLang = savedLang || 'sq';
    this.translate.setDefaultLang(defaultLang);
    this.translate.use(defaultLang);
  }

  ngOnInit() {

  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/']);
    this.hasLoggedInUser = false;
  }

  sidenavToggle() {
    this.sidenavSmall = !this.sidenavSmall;
  }

  isEmptyObject(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
    this.currentLang = lang;
    localStorage.setItem('lang', lang);
  }

}
